<template>
  <TemplatePopup
    :showMessage="saveDisabled"
    :fullScreen="fullScreen"
    :geometry="entity.geometry"
  >
    <div slot="header" class="header-container">
      <div class="header-title">
        <strong>POP</strong>
        <CreationDate :date="entity.created" />
      </div>
    </div>
    <div slot="body">
      <tabs>
        <tab title="Dados" :selected="true">
          <b-form-group label="Nome (TAG):">
            <b-form-input
              id="inputName"
              v-model="entity.name"
              :class="{ 'is-invalid': missingName }"
              maxlength="50"
              size="sm"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Endereço:">
            <b-form-input
              id="inputAddress"
              v-model="entity.address"
              :class="{ 'is-invalid': missingAddress }"
              maxlength="255"
              :disabled="entity.category === 'I'"
              size="sm"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Endereços sugeridos:" v-if="isNew && entity.category !== 'I'">
            <b-form-select id="addressList" v-model="entity.address" size="sm">
              <b-form-select-option
                v-for="address in addressList"
                :value="address.formatted_address"
                :key="address.formatted_address"
              >
                {{ address.formatted_address }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Bloco:" v-if="entity.category === 'I'">
            <b-form-input
              id="inputBlock"
              v-model="entity.block"
              maxlength="50"
              size="sm"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Andar:" v-if="entity.category === 'I'">
            <b-form-input
              type="number"
              id="inputFloor"
              v-model="entity.floor"
              size="sm"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Pasta:">
            <b-form-select
              id="selectFolder"
              v-model="entity.folderId"
              size="sm"
            >
              <b-form-select-option
                v-for="entityList in folderList"
                :value="entityList.id"
                :key="entityList.id"
              >
                {{ entityList.name }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Cor:">
            <ColorSelect id="colorList" v-model="entity.color" size="sm" :valueDefault="color"/>
          </b-form-group>
        </tab>
        <tab
          id="tabCables"
          title="Cabos"
          v-if="!isNew"
          :permission="['CAB', 'VI']"
        >
          <Cables :equipmentId="entity.id" />
        </tab>
        <tab id="tabOLT" title="OLT" v-if="!isNew" :permission="['OLT', 'VI']">
          <Olt :equipmentId="entity.id" :updateAction="null" />
        </tab>
        <tab id="tabDIO" title="DIO" v-if="!isNew" :permission="['DIO', 'VI']">
          <Dio :equipmentId="entity.id" :updateAction="null" />
        </tab>
        <tab
          id="tabSplitter"
          title="Splitter"
          v-if="!isNew"
          :permission="['SPL', 'VI']"
        >
          <Splitter
            ref="splitterTab"
            :equipmentId="entity.id"
            :updateAction="null"
            :showAttendance="false"
          />
        </tab>
        <tab
          id="tabSwitch"
          title="Switch"
          v-if="!isNew"
          :permission="['SWT', 'VI']"
        >
          <SwitchTab
            :equipmentId="entity.id"
            :updateAction="null"
          />
        </tab>
      </tabs>
    </div>
    <div slot="button">
      <div class="text-center">
        <b-button-group>
          <b-button
            id="btnOtdr"
            @click.prevent="OTDR()"
            v-has-permission.permission="['OTR', 'VI']"
            variant="muted"
            :disabled="isNew"
          >
            <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">OTDR</p>
          </b-button>

          <b-button
            id="btnReport"
            @click.prevent="connectionReport()"
            v-has-permission.permission="['REL', 'VI']"
            variant="muted"
            :disabled="isNew"
          >
            <i class="fa fa-bar-chart fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">Relatório</p>
          </b-button>

          <b-button
            id="btnComments"
            @click.prevent="comment()"
            v-has-permission.permission="['COM', 'VI']"
            variant="muted"
            :disabled="isNew"
          >
            <i class="fa fa-comments fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">Comentários</p>
          </b-button>

          <b-button
            id="btnImage"
            @click.prevent="image()"
            v-has-permission.permission="['IMG', 'VI']"
            variant="muted"
            :disabled="isNew"
          >
            <i class="fa fa-picture-o fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">Imagem</p>
          </b-button>

          <b-button
            id="btnConnections"
            @click.prevent="conexao()"
            v-has-permission.permission="['CON', 'VI']"
            variant="muted"
            :disabled="isNew"
          >
            <i class="fa fa-sitemap fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">Conexões</p>
          </b-button>

          <b-button
            id="btnDelete"
            @click.prevent="remove()"
            v-has-permission.permission="['POP', 'EX']"
            variant="muted"
            :disabled="isNew"
          >
            <i class="fa fa-times-circle fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">Excluir</p>
          </b-button>

          <b-button
            id="btnSave"
            @click.prevent="save()"
            v-has-permission.permission="['POP', 'AL', 'CA']"
            variant="muted"
            :disabled="saveDisabled"
          >
            <i class="fa fa-floppy-o fa-lg"></i>
            <p class="button-text mb-0">Salvar</p>
          </b-button>
        </b-button-group>
      </div>
    </div>
  </TemplatePopup>
</template>

<script>
import TemplatePopup from "../../../template/TemplatePopup";
import { popPath, folderSimplePath } from "../../../router/ApiPaths";
import PopupBase from "./PopupBase";
import Tabs from "./Tabs/Tabs";
import Tab from "./Tabs/Tab";
import Dio from "./Tabs/Dio";
import Splitter from "./Tabs/Splitter";
import Olt from "./Tabs/Olt";
import SwitchTab from './Tabs/Switch';
import CreationDate from "./CreationDate"
import Cables from "./Tabs/Cables";
import ColorSelect from "../../map/components/ColorSelect.vue";
import { getAction } from "../../../components/MessageBus";
import { openSubPopup } from "./index";

export default {
  name: "PopMap",
  extends: PopupBase,
  components: {
    TemplatePopup,
    Dio,
    Splitter,
    Olt,
    Tabs,
    Tab,
    SwitchTab,
    CreationDate,
    Cables,
    ColorSelect
  },
  data() {
    return {
      folderList: [],
      color: "red"
    };
  },
  beforeMount() {
    this.entity = {
      id: null,
      cable: null,
      popModel: {},
      mappingDate: {},
      splitterModel: {},
      geometry: null,
      color: this.color,
      category: this.extra && this.extra.category ? this.extra.category : "E",
      address:
        this.extra && this.extra.address
          ? this.extra.address
          : this.entity.address,
      equipmentExternalId:
        this.extra && this.extra.equipmentExternalId
          ? this.extra.equipmentExternalId
          : undefined,
      positionDiagram:
        this.extra && this.extra.positionDiagram
          ? this.extra.positionDiagram
          : undefined,  
    };
    console.log('entity:', this.entity);
  },
  mounted: function () {
    let path = popPath(this.folderId);

    this.getAllDirect(folderSimplePath).then((data) => {
      this.folderList = data;
    });

    if (this.extra && this.extra.category === "I") this.init(path);
    else this.init(path, true, this.isNew);

    let today = new Date().toISOString().substr(0, 10);
    this.entity.mappingDate = today;
    
    if(!this.entity.color) {
      this.entity.color = this.color;
    }
  },
  computed: {
    missingName: function () {
      return !this.entity.name;
    },
    missingAddress: function () {
      return !this.entity.address;
    },
    saveDisabled() {
      return this.missingName || this.missingAddress || !this.isDirty;
    },
  },
  methods: {
    conexao() {
      openSubPopup(3, null, this.id || this.entity.id, this.entity);

      getAction((result) => {
        if (result) {
          this.getOne();
          this.atualizarListaSplitters();
        }
      });
    },
    atualizarListaSplitters() {
      if (this.$refs.splitterTab && typeof this.$refs.splitterTab.atualizaDados === 'function') {
        this.$refs.splitterTab.atualizaDados();
      }
    }
  }
};
</script>
